export const FILE_BASE_URL =
  "https://lsaswmuatapi.vmaxtechservices.help/swmp2images/";

// Dev / UAT Base
export const API_BASE_URL1 = "https://lsaswmuatapi.vmaxtechservices.help/v1/";
export const API_BASE_URL3 = "https://lsaswmuatapi.vmaxtechservices.help/v2/";
export const API_BASE_URL = "https://lsaswmuatapi.vmaxtechservices.help/";

//production URL
// export const API_BASE_URL1 = "https://uatlsaswmapi.lucknowswachhata.com/v1/";
// export const API_BASE_URL3 = "https://uatlsaswmapi.lucknowswachhata.com/v2/";
// export const API_BASE_URL = "https://uatlsaswmapi.lucknowswachhata.com/";


//production URL
//export const API_BASE_URL1 = "https://lsaswmapi.lucknowswachhata.com/v1/";
//export const API_BASE_URL3 = "https://lsaswmapi.lucknowswachhata.com/v2/";
//export const API_BASE_URL = "https://lsaswmapi.lucknowswachhata.com/";


//uat
// export const API_BASE_URL1 ="http://localhost:5250/v1/";
// export const API_BASE_URL3 ="http://localhost:5250/v2/";
// export const API_BASE_URL = "http://localhost:5250/";


//export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";

//GOOGLE MAP
export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";
